/**
 * Copyright IBM Corp. 2022, 2026
 */

import BlueskyEmbed from './bluesky'
// ! TODO Uncomment once we have access to a Meta developer key
// import InstagramEmbed from './instagram'
import LinkedInEmbed from './linkedin'
import RedditEmbed from './reddit'
import TiktokEmbed from './tiktok'
import TwitterEmbed from './twitter'
import s from './style.module.css'

const SUPPORTED_PLATFORMS = [
	'bluesky',
	'bsky',
	'instagram',
	'linkedin',
	'reddit',
	'tiktok',
	'twitter',
	'x',
]

export default function SocialEmbed({ url }) {
	const hostname = new URL(url).hostname.replace('www.', '')
	const platform = hostname?.split('.')[0]
	if (!SUPPORTED_PLATFORMS.includes(platform)) {
		return (
			<p className={s.unsupported}>
				Unfortunately this embed&apos;s platform is not supported. Please use a
				URL from a supported platform.
			</p>
		)
	}

	switch (platform) {
		case 'bluesky':
		case 'bsky':
			return <BlueskyEmbed url={url} />
		// ! TODO Uncomment once we have access to a Meta developer key
		// case 'instagram':
		// 	return <InstagramEmbed url={url} />
		case 'linkedin':
			return <LinkedInEmbed url={url} />
		case 'reddit':
			return <RedditEmbed url={url} />
		case 'tiktok':
			return <TiktokEmbed url={url} />
		case 'twitter':
		case 'x':
			return <TwitterEmbed url={url} />
		default:
			break
	}
}
